<template>

<div>
  <div v-if="loading">
    <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
  </div>
  <div class="sa-con-set" v-else>
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div class="sa-row">
        <div
          class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4 sa-card-none"
          v-if="userInfo.eid !== 'HSP1' && userInfo.eid !== 'HSP0'"
        >
          <div class="sa-card sa-card-gray sa-card-noshadow sa-card-border">
            <div class="sa-form-group sa-d-f-sbetween">
              <span class="sa-blue-text">Home Visit</span>
              <!-- <div class="sa-switch sa-ciyan-blue">
                <input type="checkbox" id="homeVis" checked />
                <label for="homeVis">
                  <span class="sa-input-box"></span>
                </label>
              </div> -->
            </div>
            <div class="sa-cons-text" >
            <div class="sa-form-group">
              <label>Consultation Fee (SAR)</label>
              <i class="sa-form-icon"></i>
              <ValidationProvider
                name="consultation fee"
                rules="requiredss"
                v-slot="{ errors }"
              >
                <input type="number" class="sa-line-input" v-model="services.ST0.FEE.VALUE"  name="consultation fee" id="consultationFee" placeholder="Enter consultation fee"  />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="sa-form-group  sa-mb0">
              <label>Duration (Min)</label>
              <v-select :options="duration" v-model="services.ST0.DURATION" label='dur' id="durationMin" name="Duration (Min)" placeholder="Enter Duration (Min)" ><span slot="no-options">No data</span></v-select>
            </div>
            </div>
          </div>
        </div>
        <div class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4 sa-card-none">
          <div class="sa-card sa-card-gray sa-card-noshadow sa-card-border">
            <div class="sa-form-group sa-d-f-sbetween">
              <span class="sa-blue-text">Video consultation</span>
              <!-- <div class="sa-switch sa-ciyan-blue">
                <input type="checkbox" id="videoCon" checked />
                <label for="videoCon">
                  <span class="sa-input-box"></span>
                </label>
              </div> -->
            </div>
            <div class="sa-cons-text">
            <div class="sa-form-group">
              <label>Consultation Fee (SAR)</label>
              <i class="sa-form-icon"></i>
              <ValidationProvider
                name="consultation fee"
                rules="required"
                v-slot="{ errors }" tag="div"
              >
                <input type="number" class="sa-line-input" v-model="services.ST1.FEE.VALUE" name="consultation fee" id="consultationFee" placeholder="Enter consultation fee" />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="sa-form-group sa-mb0">
              <label>Duration (Min)</label>
              <v-select :options="duration"  v-model="services.ST1.DURATION" label='dur' id="Duration Min" name="Duration (Min)" placeholder="Enter Duration (Min)" :disabled="!services.editable"><span slot="no-options">No data</span></v-select>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="services && services.editable" class="sa-text-right">
        <button
          class="sa-btn sa-btn-primary sa-btn-large"
          @click="handleSubmit(addConsultation)"
        >Save
      </button>
      </div>
    </ValidationObserver>
  </div>
</div>
</template>

<script>
import { pro_url } from "../../../config/endpoints";
import { extend } from 'vee-validate';
import { required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: " Provide {_field_}"
});
// extend("integer", {
//   ...integer,
//   message: "Consultation fee must be a numeric"
// });

export default {
  data() {
    return {
      duration: [15, 20, 30, 45, 60],
      userInfo: {},
      services: {
        ST0: {
          DURATION: "",
          FEE: {}
        },
        ST1: {
          DURATION: "",
          FEE: {}
        }
      },
      loading: false,
    };
  },
  methods: {
    addConsultation() {
      let _self = this;
     _self.loading = true;
      let req = {};
      if (_self.services.ST0.DURATION) {
        req["ST0"] = {
          dur: _self.services.ST0.DURATION,
          fee: {
            val: _self.services.ST0.FEE.VALUE
          }
        };
      }
      if (_self.services.ST1.DURATION) {
        req["ST1"] = {
          dur: _self.services.ST1.DURATION,
          fee: {
            val: _self.services.ST1.FEE.VALUE
          }
        };
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/addServiceTypeConfig`,
          body: { st: req }
        })
        .then(response => {
         _self.loading = false;
          if (response && response.status === 1000) {
            _self.$store.dispatch('SET_ALERTMESSAGE', { msg: response.message, class: 'sa-a-success' })            
          } else if (response && response.status == "2001") {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Session Expired. Please login again",
              class: "sa-a-danger",
            });
            _self.$localStorage.remove("token");
            _self.$localStorage.remove("userdata");
            _self.$router.push({ path: "/" });
          } else {
            _self.$store.dispatch('SET_ALERTMESSAGE', { msg: response.message, class: 'sa-a-danger' })

          }
        });
    },
    getConsultation() {
      let _self = this;
      _self.loading = true;
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/v1/getServiceTypeConfig`,
          body: {}
        })
        .then(response => {
          if (response.status === 1000) {
            if (response.data.services.ST0) {
              _self.services.ST0 = response.data.services.ST0;
              _self.services["editable"] = response.data.editable;
            }
            if (response.data.services.ST1) {
              _self.services.ST1 = response.data.services.ST1;
              _self.services["editable"] = response.data.editable;
            }
          }
           _self.loading = false;
        })
        .catch(e => {
         // console.log(e);
        });
       
    }
  },
  created() {
    let _self = this;
    _self.getConsultation();
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
  }
};
</script>